
import { ReactNode } from 'react';
import { useUserProgress } from '@/hooks/use-user-progress';
import BusinessAssessmentPrompt from './BusinessAssessmentPrompt';
import { LoadingState } from '@/components/ui/loading-states';

interface AssessmentGateProps {
  children: ReactNode;
  onAssessmentComplete: () => void;
}

export function AssessmentGate({ children, onAssessmentComplete }: AssessmentGateProps) {
  const { progress, isLoading } = useUserProgress();

  if (isLoading) {
    return <LoadingState message="Checking your progress..." />;
  }

  if (!progress.hasCompletedAssessment) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="max-w-4xl w-full">
          <div className="bg-gradient-to-r from-cso-50 to-blue-50 border border-cso-200 rounded-lg p-8">
            <BusinessAssessmentPrompt onAssessmentComplete={onAssessmentComplete} />
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
